import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { useDevCenterOverridesClient } from '@wix/dev-center-overrides-client';
import { Alert, Spinner, useAsyncCallback } from '@wix/cli-ui-kit';
import { useProjectModel } from '../../model.js';
import { CreatePreview } from './Steps/CreatePreview.js';

interface PromoteCommandProps {
  baseUrl?: string;
  label?: string;
}

export const PromoteCommand: FC<PromoteCommandProps> = ({ baseUrl, label }) => {
  const {
    model: {
      config: { appId },
    },
  } = useProjectModel();

  const devCenterOverrides = useDevCenterOverridesClient();

  const promoteAction = useAsyncCallback(async (_, previewId: string) => {
    await devCenterOverrides.createDraftVersion(appId, previewId);
  });

  function onPreviewCreated({ previewId }: { previewId: string }) {
    return promoteAction.execute(previewId);
  }

  return (
    <>
      <CreatePreview
        baseUrl={baseUrl}
        label={label}
        onCreated={onPreviewCreated}
      />
      {match(promoteAction.status, {
        Loading: () => <Spinner text={`Promoting app draft...`} />,
        Success: () => (
          <Alert type="success">App draft promoted successfully</Alert>
        ),
        Error: () => null,
        NotRequested: () => null,
      })}
    </>
  );
};
